function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconImageRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 25h20V7H6v18zM28 3H4a2 2 0 00-2 2v22a2 2 0 002 2h24a2 2 0 002-2V5a2 2 0 00-2-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 21.407l-3.555-3.555-1.586 1.586 1.128 1.128-1.414 1.414-6.128-6.128L8 20.297V23h16v-1.594z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 11a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0020.5 11zm-3.055 7.023l-5-5L8 17.468V9h16v9.578l-3.555-3.555-3 3z",
    fill: props.color
  }));
}

export default SvgIconImageRexFilled;